<template id="cmsForm">
<div>
        <div class="row mt-3">
            <div class="col-md-10">
                <h3>
                     {{ product.code_in_store }} {{ product.name_in_store }}
                </h3>
            </div>
        </div>                
        <div class="row">                
            <div class="col-md-6">
                <div class="card" style="width:100%;">                        
                    <div class="card-body">
                        <img :src="mainImgSrc" class="card-img-top main-product-img" alt="">
                    </div>
                    <div class="card-footer" v-if="product.imgs.subs.length>1">
                        <div class="row">
                            <div class="col-md-3">
                                <a href="#" @click="changeMainImgSrc(product.imgs.main)">
                                    <img :src="product.imgs.main" class="img-thumbnail ml-0 pl-0" alt="">
                                </a>                                
                            </div>                            
                            <div class="col-md-3" v-for="subimg,key in product.imgs.subs" v-bind:key="key">
                                <a href="#" @click="changeMainImgSrc(subimg)"><img :src="subimg" class="img-thumbnail ml-0 pl-0" alt=""></a>
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                
                
                <div class="row" v-for="field in fields" v-bind:key="field.title">
                    <div class="col-md-4">                            
                        <span class="float-right">{{field['title']}}</span>                           
                    </div>
                    <div class="col-md-8">                            
                        {{ field['show'] }}
                    </div>
                </div>                    
                
                <div class="row">
                    <div class="col-md-4">                            
                        <span class="float-right">Category</span>                           
                    </div>
                    <div class="col-md-8">                            
                        <span class="badge badge-success ml-1"> {{product.category.name}} </span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">                            
                        <span class="float-right">tags</span>                           
                    </div>
                    <div class="col-md-8">
                        <span class="badge badge-success ml-1" v-for="(tag,tgId) in product.tags" v-bind:key="tgId+'_'+tag.id"> {{tag.key}}:{{tag.value}} </span>
                    </div>
                </div>
                <div class="row">
                    <hr>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <a href="/product" class="btn btn-secondary  float-right">กลับ</a
                        >                         
                    </div>
                </div>
            </div>                
        </div>        
    </div>
</template>
<script>
export default {
    props: {
        //item_id ถูกส่งผ่านมาทาง form.blade.php ใน tag component (:item_id="{{empty($id) ? '0' : $id}}")
        //กรณีที่เป็น การ add item_id จะ เท่ากับ 0
        item_id: "",
        store_id:"",
    },
    data() {
        return {            
            base_url: "/product", // base url (เปลี่ยน)
            previewImage: null, //เอาไว้เก็บ preview ของภาพ ก่อนอัพโหลด
            product:{
                imgs:{
                    main:'',
                    subs:[],
                },
                category:{
                    name:'',
                },
            },
            fields:{},
            mainImgSrc:'',
        };
    },
    mounted() {        
    },
    beforeMount() {},
    created() {
        this.load(this.item_id);
    },
    methods: {
        changeMainImgSrc(src){
            this.mainImgSrc = src;    
        },
        load(id) {
            console.log('load:',id);
            axios
                .get(this.base_url + '/show/'+ id)
                .then(response => {
                    console.log('product:',response.data.products.items[0]);
                    this.product = response.data.products.items[0];
                    this.mainImgSrc = this.product.imgs.main;
                    this.initFields();
                })
                .catch(errors => {
                    console.log(errors);
                });
        },
        initFields(){
            let product = this.product
            this.fields = [
                {"title":"ชื่อเรียกในร้าน","show":product.code_in_store+' '+product.name_in_store},
                {"title":"ชื่อเรียกทั่วไป","show":product.code_in_common+' '+product.name_in_common},
                {"title":"ราคาในร้าน","show":parseInt(product.price_in_store).toLocaleString()+' บาท'},
                {"title":"main image link","show":product.imgs.main},
                {"title":"สาถานะ","show":product.status},
                {"title":"ข้อมูลย่อ","show":product.brief},
                {"title":"รายละเอียด","show":product.detail},
                {"title":"ขนาด","show":product.size},
                {"title":"category","show": product.category.name},                
            ]
        },        
        
    }
};
</script>
